import React, { useState, useEffect } from "react";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";

import { toast } from "react-toastify";
import equipmentGroupConstants from "../../../Constants/EquipmentGroupConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import GridTable from "../../ReusableComponent/GridTable/GridTable";
import { useLanguageContext } from "../../../Context/LanguageContext";

const initalValue = {
  data: [],
  headerName: [],
  headers: {},
  filterName: [],
};

export default function FilterEquipmentList() {
  const { localization } = useLanguageContext();
  const [tableData, setTableData] = useState(initalValue);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  useEffect(() => {
    function getEquipmentListSuccess() {
      const response = equipmentGroupStore.getEquipmentListGrid();
      if (response) {
        let headerName = [];
        let _header = response.headers;
        let _rows = response.rows;
        let _idPos;
        let _tempHeaders = [];

        _header.map((item) => {
          headerName.push(item.name);
          _tempHeaders.push({
            ...item,
            actions: [],
          });
        });
        headerName.map((item, index) => {
          if (item === "ID") {
            _idPos = index;
          }
        });

        setTableData({
          data: _rows,
          headerName: headerName,
          headers: _tempHeaders,
          sortBy: {
            key: "inventry",
            order: "asc",
            className: "",
          },
        });

        setGlobalSpinner(false);
      }
    }

    function getEquipmentListFailure() {
      const res = equipmentGroupStore.getEquipmentListGrid();
      toast.error(res);
      setTableData(initalValue);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_SUCCESS,
      getEquipmentListSuccess
    );

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_FAILURE,
      getEquipmentListFailure
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_SUCCESS,
        getEquipmentListSuccess
      );
      equipmentGroupStore.addChangeListener(
        equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_FAILURE,
        getEquipmentListFailure
      );
    };
  }, []);

  function handlePopOverClose() {
    setTableData(initalValue);
  }
  return (
    <div
      className="modal fade"
      id="filterEquipmentlistpopOver"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="filterEquipmentlistpopOver"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div
        className="modal-dialog d-flex justify-content-center emailheadFoler"
        role="document"
      >
        <div className="modal-content ">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentListTitle">
              {localization.equipmentList}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="filterEquipmentlistModalClose"
              onClick={handlePopOverClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="table-responsive px-3 equipmentListHeightMax">
              <GridTable data={tableData} handleAction={[]} requestSort={[]} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
